import { Card, CardContent, Paper, Stack, Typography, Box, Divider } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { getCountryLabelByCode } from "../../utility/countries";
import ControlPointIcon from '@mui/icons-material/ControlPoint';

export default function ContractorSearchResultCard(props) {
    const data = props.data;

    function isNotEmpty(value) {
        return value != null && value != undefined && value != '';
    }

    function getAddressLine(data) {
        return data.address.street +
            (isNotEmpty(data.address.houseNumber) ? (' ' + data.address.houseNumber) : '') +
            (isNotEmpty(data.address.apartmentNumber) ? ('/'+data.address.apartmentNumber) : '') + 
            (isNotEmpty(data.address.country) ? (', '+ getCountryLabelByCode(data.address.country)) : '');
            
    }

    const isTemporary = props.data.temporary ?? false;

    return (
        <MDBox>
            {isTemporary ? (
                <Stack direction="row">
                    <ControlPointIcon color='text' sx={{mr:1}} fontSize="medium"/><MDTypography color='text' fontSize={14} fontWeight='fontWeightMedium'>Dodaj kontrahenta: {data.name}</MDTypography>
                </Stack>
                
            ) : (
                <MDBox>
                    <MDTypography color='text' fontSize={14} fontWeight='fontWeightMedium'>{data.name}</MDTypography>
                    <MDTypography color='text' fontSize={14} sx={{mt:1}}>NIP: {data.nip.nip}</MDTypography>
                    <MDTypography color='text' fontSize={14}>{getAddressLine(data)}</MDTypography>
                </MDBox>
            )}
        </MDBox>
    )
}